import { useContext, useState, useEffect } from "react"
import RegistrationPage from "../_components/register"
import { GetUserReturnType } from "../../../context/commonFunctionContext"
import { OnSuccessfulAuthCallback } from "../../../components/auth/context"
import { RegisterFormProvider } from "../../../components/auth/register-form/context"
import { SubscriptionContext } from "../../../components/subscription"
import { useLocation } from "react-router-dom"
import { useSearchParams } from "react-router-dom"
import { VerifyPhone } from "../../../api/app.service"
import { useToast } from "../../../hooks/useToast"

export enum StepType {
  Email = "email",
  VerifyEmail = "verify-email",
  VerifyPhone = "verify-phone",
  CreateAccount = "create-account",
  IINCheckout = "iin-checkout",
  EnrollmentFinal = "enrollment-final",
}

interface LocationState {
  from?: string
}

export default function WrappedIINRegistrationPage() {
  const [step, setStep] = useState<StepType>(StepType.Email)
  const [loading, setLoading] = useState(false)
  const { toast } = useToast()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const locationState = location.state as LocationState
  const returnUser = searchParams.get("returnUser") || false
  const [isIIN, setIsIIN] = useState(true)


  const [appliedDiscount, setAppliedDiscount] = useState<any>({
    amount: 0,
    promoCode: "",
  })
  const { createSetupIntent } = useContext(SubscriptionContext)
  const [isTermsAgreed, setIsTermsAgreed] = useState<boolean>(false)

  const onSuccess: OnSuccessfulAuthCallback = (user: GetUserReturnType) => {
    if (user) {
      VerifyPhone.sendPhoneCode({ access_token: user.access_token })
        .then((data) => {
          setLoading(false)
          data.message === "complete" && setStep(StepType.VerifyPhone)
        })
        .catch((err) => {
          console.error(err)
          toast.error(err.response.data.message)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  useEffect(() => {
    if (returnUser) {
      setStep(StepType.IINCheckout)
    }
  }, [returnUser])

  return (
    <RegisterFormProvider
      defaultEmail=""
      defaultAccountType="coach"
      defaultFirstName=""
      defaultLastName=""
      defaultPassword=""
      defaultPhone=""
      onSuccess={onSuccess}
    >
      <RegistrationPage
        isIIN={isIIN}
        step={step}
        setStep={setStep}
        loading={loading}
        setLoading={setLoading}
        appliedDiscount={appliedDiscount}
        createSetupIntent={createSetupIntent}
        isTermsAgreed={isTermsAgreed}
        setIsTermsAgreed={setIsTermsAgreed}
        selectedPlanFromChild=""
      />
    </RegisterFormProvider>
  )
}